import * as moment from "moment-timezone";
import * as React from "react";
import styled from "styled-components";

import HtmlBody from "src/library/components/Notes/HtmlBody";

import { IListNote } from "../api/lists.api";

interface ListNoteProps {
  note: IListNote;
}

const ListNote: React.ReactFCWithChildren<ListNoteProps> = props => {
  return (
    <Container>
      <NoteWrapper>
        <HtmlBody body={props.note.body} />

        <SubText>
          {`Updated by ${props.note.source} at ${moment
            .utc(props.note.updatedAt)
            .local()
            .format("HH:mm DD/MM/YY")}`}
        </SubText>
      </NoteWrapper>
    </Container>
  );
};

const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing.margins.xs};
  display: flex;
  border-radius: ${({ theme }) => theme.borderRadius};
  background: white;
  padding: ${({ theme }) => theme.spacing.padding.md};
  width: 100%;
`;

const NoteWrapper = styled.div`
  width: 100%;
`;

const SubText = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.sub};
  padding-top: ${({ theme }) => theme.spacing.padding.md};
`;

export default ListNote;
